import AccessoryDelete from './accessories/AccessoryDelete';
import AccessoryIndex from './accessories/AccessoryIndex';
import AccessoryView from './accessories/AccessoryView';
import Accounting from './dashboard/Accounting';
import Availabilities from './Availabilities';
import BankingExportIndex from './payments/BankingExportIndex';
import BankingExportView from './payments/BankingExportView';
import BookingAssign from './bookings/BookingAssign';
import BookingCancel from './bookings/BookingCancel';
import BookingCollect from './bookings/BookingCollect';
import BookingCreate from './bookings/BookingCreate';
import BookingDelete from './bookings/BookingDelete';
import BookingSearch from './bookings/BookingSearch';
import BookingResolve from './bookings/BookingResolve';
import BookingReturn from './bookings/BookingReturn';
import BookingStatusIndex from './bookings/BookingStatusIndex';
import BookingView from './bookings/BookingView';
import CompanyDelete from './companies/CompanyDelete';
import CompanyIndex from './companies/CompanyIndex';
import CompanyMerge from './companies/CompanyMerge';
import CompanyView from './companies/CompanyView';
import CRM from './dashboard/CRM';
import Dashboard from './Dashboard';
import DriverDelete from './drivers/DriverDelete';
import DriverIndex from './drivers/DriverIndex';
import DriverMerge from './drivers/DriverMerge';
import DriverView from './drivers/DriverView';
import HistoryIndex from './history/HistoryIndex';
import HistoryView from './history/HistoryView';
import HolidayDelete from './holidays/HolidayDelete';
import HolidayIndex from './holidays/HolidayIndex';
import HolidayView from './holidays/HolidayView';
import Home from './Home';
import Login from './auth/Login';
import Logout from './auth/Logout';
import NotesIndex from './notes/NotesIndex';
import PaymentsIndex from './payments/PaymentsIndex';
import PaymentsView from './payments/PaymentsView';
import PendingAccountPaymentsView from './payments/PendingBookingPaymentsView';
import PendingBookingPaymentsIndex from './payments/PendingBookingPaymentsIndex';
import PreAuthBookingIndex from './payments/PreAuthBookingIndex';
import PreAuthBookingView from './payments/PreAuthBookingView';
import ReservationCreate from './reservations/ReservationCreate';
import ReservationDelete from './reservations/ReservationDelete';
import ReservationView from './reservations/ReservationView';
import ServiceHistoryIndex from './service/ServiceHistoryIndex';
import ServiceView from './service/ServiceView';
import ServicingIndex from './service/ServicingIndex';
import Settings from './Settings';
import SettingsIndex from './settings/SettingsIndex';
import Signatures from './signatures/Signatures';
import StatisticsIndex from './statistics/StatisticsIndex';
import UserDelete from './users/UserDelete';
import UserIndex from './users/UserIndex';
import UserView from './users/UserView';
import VehicleDelete from './vehicles/VehicleDelete';
import VehicleIndex from './vehicles/VehicleIndex';
import VehicleTypeDelete from './vehicleTypes/VehicleTypeDelete';
import VehicleTypeIndex from './vehicleTypes/VehicleTypeIndex';
import VehicleTypeView from './vehicleTypes/VehicleTypeView';
import VehicleView from './vehicles/VehicleView';
import PaymentDelete from './payments/PaymentDelete';

export default [
  // Generic
  { path: '/', component: Home },
  { path: '/login', component: Login },
  { path: '/logout', component: Logout },
  { path: '/notes', component: NotesIndex },
  { path: '/settings', component: Settings },
  { path: '/availabilities/', component: Availabilities },
  { path: '/availabilities/:period', component: Availabilities },

  // Dashboard
  { path: '/dashboard', component: Dashboard },
  { path: '/dashboard/crm', component: CRM },
  { path: '/dashboard/accounting', component: Accounting },

  // History Calendar
  { path: '/history', component: HistoryIndex },
  { path: '/history/:period', component: HistoryIndex },
  { path: '/history/:period/:date', component: HistoryView },

  // Companies
  { path: '/companies', component: CompanyIndex },
  { path: '/companies/:id', component: CompanyView },
  { path: '/companies/:id/history/:revisionId', component: CompanyView },
  { path: '/companies/:id/merge/:mergeCompanyId', component: CompanyMerge },
  { path: '/companies/:id/delete', component: CompanyDelete },

  // Drivers
  { path: '/drivers', component: DriverIndex },
  { path: '/drivers/:id', component: DriverView },
  { path: '/drivers/:id/history/:revisionId', component: DriverView },
  { path: '/drivers/:id/merge/:mergeDriverId', component: DriverMerge },
  { path: '/drivers/:id/delete', component: DriverDelete },

  // Users
  { path: '/settings/users', component: UserIndex },
  { path: '/settings/users/:id', component: UserView },
  { path: '/settings/users/:id/delete', component: UserDelete },

  // Vehicle Types
  { path: '/settings/vehicles/types', component: VehicleTypeIndex },
  { path: '/settings/vehicles/types/:id', component: VehicleTypeView },
  { path: '/settings/vehicles/types/:id/delete', component: VehicleTypeDelete },

  // Vehicles
  { path: '/settings/vehicles', component: VehicleIndex },
  { path: '/settings/vehicles/:id', component: VehicleView },
  {
    path: '/settings/vehicles/:id/history/:revisionId',
    component: VehicleView,
  },
  { path: '/settings/vehicles/:id/delete', component: VehicleDelete },

  // Holidays
  { path: '/settings/holidays', component: HolidayIndex },
  { path: '/settings/holidays/:id', component: HolidayView },
  { path: '/settings/holidays/:id/delete', component: HolidayDelete },

  // Reservations
  { path: '/reservations/create', component: ReservationCreate },
  { path: '/reservations/:id', component: ReservationView },
  { path: '/reservations/:id/delete', component: ReservationDelete },

  // Accessories
  { path: '/settings/accessories', component: AccessoryIndex },
  { path: '/settings/accessories/:id', component: AccessoryView },
  { path: '/settings/accessories/:id/delete', component: AccessoryDelete },

  // Bookings
  { path: '/bookings/status/:status', component: BookingStatusIndex },
  { path: '/bookings/status/:status/:period', component: BookingStatusIndex },
  { path: '/bookings/create', component: BookingCreate },
  { path: '/bookings/search', component: BookingSearch },
  { path: '/bookings/:id', component: BookingView },
  { path: '/bookings/:id/history/:revisionId', component: BookingView },
  { path: '/bookings/:id/collect', component: BookingCollect },
  { path: '/bookings/:id/assign', component: BookingAssign },
  { path: '/bookings/:id/delete', component: BookingDelete },
  { path: '/bookings/:id/cancel', component: BookingCancel },
  { path: '/bookings/:id/resolve', component: BookingResolve },
  { path: '/bookings/:id/return', component: BookingReturn },

  // Payments
  { path: '/payments', component: PaymentsIndex },
  { path: '/payments/pre-auth', component: PreAuthBookingIndex },
  { path: '/payments/pre-auth/:id', component: PreAuthBookingView },
  { path: '/payments/pending-account', component: PendingBookingPaymentsIndex },
  { path: '/payments/:id/delete', component: PaymentDelete },
  {
    path: '/payments/pending-account/:company_id',
    component: PendingBookingPaymentsIndex,
  },
  {
    path: '/payments/pending-account/:company_id/:id',
    component: PendingAccountPaymentsView,
  },
  { path: '/payments/banking-export', component: BankingExportIndex },
  { path: '/payments/banking-export/:id', component: BankingExportView },
  { path: '/payments/:id', component: PaymentsView },

  // Settings
  { path: '/settings/settings', component: SettingsIndex },

  // Signatures
  { path: '/signatures', component: Signatures },

  // Service History
  { path: '/service/history', component: ServiceHistoryIndex },
  { path: '/service', component: ServicingIndex },
  { path: '/service/:id', component: ServiceView },

  // Statistics
  { path: '/statistics', component: StatisticsIndex },
];
